"use client";
import dynamic from "next/dynamic";

const BlockAudioPlayerWithTranscriptRotater = dynamic(() =>
  import(".").then(mod => mod.BlockAudioPlayerWithTranscriptRotater),
);
const BlockAudioPlayerWithTranscriptSlider = dynamic(() =>
  import(".").then(mod => mod.BlockAudioPlayerWithTranscriptSlider),
);

export { BlockAudioPlayerWithTranscriptRotater, BlockAudioPlayerWithTranscriptSlider };
